import React, { useEffect, useState } from 'react';

//Material
import { Modal, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// import styled from '@emotion/styled';
import './PostModal.css';
import ImageGallery from 'react-image-gallery';
import { setIsOpenFullscreenPicture } from '../../redux/mainReducer';
import { connect, useDispatch } from 'react-redux';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: '100%',
  maxWidth: { xs: '390px', sm: '820px', md: 1300 },
  minWidth: '50vh',
  bgcolor: 'unset',

  borderRadius: '20px',
  border: 'none',
  padding: '50px 50px 0px 50px',
  overflow: 'hidden',
  minHeight: '50vh !important',
  maxHeight: '90vh',
  // minHeight: '40vh',
  backgroundSize: 'contain',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

// const CssTextField = styled(TextField)({
//   '& label.Mui-focused': {
//     color: '#000000'
//   },
//   '& label': {
//     color: '#A1A1A1',

//   },

//   margin: '5px 0px'
// });

function FullscreenPicture({ pic, isOpenModal, setShowedImg, sliderStartIdx }) {
  // eslint-disable-next-line
  const [screenType, setScreenType] = useState('desktop');
  const dispatch = useDispatch();
  useEffect(() => {
    if (window.screen.width <= 600) {
      setScreenType('mobile');
    }
  }, []);

  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          setShowedImg([]);
          dispatch(setIsOpenFullscreenPicture(false));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_post_modal"
      >
        <Box sx={{ ...style }} className="bonfair_fullscreen_modal-box">
          <CloseIcon
            className="bonfair_post_modal-close"
            sx={{
              position: 'absolute',
              right: '22px',
              top: '12px',
              cursor: 'pointer',
              color: 'white',
              zIndex: 99
            }}
            onClick={() => {
              dispatch(setIsOpenFullscreenPicture(false));
            }}
          />
          <ImageGallery
            style={{ marginTop: 0, maxWidth: '300px !important' }}
            showPlayButton={false}
            thumbnailPosition="bottom"
            showThumbnails={pic.length > 1}
            showBullets={false}
            showFullscreenButton={false}
            infinite={false}
            startIndex={sliderStartIdx}
            renderLeftNav={(onClick) => (
              <div
                onClick={onClick}
                style={{
                  display: 'flex',
                  width: '40px',
                  height: '40px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  top: 'calc(50% - 15px)',
                  left: '5px',
                  zIndex: 99,
                  backgroundColor: 'rgba(255, 255, 255, 0.80)',
                  borderRadius: '50px',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                }}
              >
                <ArrowBackIosIcon
                  sx={{
                    color: 'black',
                    fontSize: '24px',
                    cursor: 'pointer',
                    ml: '8px'
                  }}
                />
              </div>
            )}
            renderRightNav={(onClick) => (
              <div
                onClick={onClick}
                style={{
                  display: 'flex',
                  width: '40px',
                  height: '40px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  top: 'calc(50% - 15px)',
                  right: '5px',
                  zIndex: 99,
                  backgroundColor: 'rgba(255, 255, 255, 0.80)',
                  borderRadius: '50px',
                  boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)'
                }}
              >
                <ArrowForwardIosIcon
                  sx={{
                    color: 'black',
                    fontSize: '24px',
                    cursor: 'pointer'
                  }}
                />
              </div>
            )}
            items={pic.map((photo) => {
              return {
                original: photo?.img,
                thumbnail: photo?.img,
                originalHeight: 652,
                originalWidth: 652,
                thumbnailHeight: 652,
                originalClass: 'service-photo-slide',
                thumbnailClass: 'thumbnailSlide'
              };
            })}
          />
          {/* <img src={URL.createObjectURL(pic)} alt="fullscreenPic" /> */}
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    isOpenSearchBar: state.global.isOpenSearchBar
  };
};
export default connect(mapStateToProps)(FullscreenPicture);
